import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { CommandPalette } from '../ui/CommandPalette';
import { ToastRenderer } from '../ui/Toast';
import '../../styles/components/fullscreen-layout.css';
export function FullscreenLayout() {
    return (_jsxs("div", { className: "fullscreen-layout", children: [_jsx(Outlet, {}), _jsx(CommandPalette, {}), _jsx(ToastRenderer, {})] }));
}
